import React, { useState } from 'react';
import { Container } from "reactstrap"
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import moment from "moment";
import signupApi from '../services/signup'
import { BsFillPersonFill, BsFillEnvelopeFill, BsFillLockFill, BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assests/css/Signup.css'
import IdleMonitor from './userAutoLogout'; //session management

const Signup = () => {
    const history = useHistory();
    const [disButton, setDisButton] = useState(false)
    const [pswdIcon, setPswdIcon] = useState(false)
    const [pswdConIcon, setConPswdIcon] = useState(false)
    const [pswdTxt, setPswdTxt] = useState("password")
    const [pswdConTxt, setConPswdTxt] = useState("password")
    const [pswdNotMatch, setPswdNotMatch] = useState(false)
    // function notify() { toast.success("Successfully login!") };

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const onSubmit = data => {
        data.time = moment().format()
        setDisButton(true);
        if (data.passwd !== data.cpasswd) {
            setPswdNotMatch(true)
        }
        else {
            signupApi(data).then(res => {
                console.log("res",res)
                if (res.success === "true") {
                    toast.success("Successfully Registered, Please verify!");
                    // console.log("Registered successfully", res.data)
                    localStorage.setItem('userId', res.data.userId);
                    localStorage.setItem('sToken', res.data.sToken);
                    localStorage.setItem('email', data.userId);
                    history.push({
                        pathname : '/verify-otp',
                        type : false
                    });
                }
                else {
                    if (res === "This emailId already exists, please enter a different email address ") {
                        toast.warning("User already exists!");
                        reset(register);
                        setDisButton(false);
                    }
                    else {
                        // console.log("Registration failed", res)
                        toast.error("Registeration Failed, Please try again!");
                        reset(register);
                        setDisButton(false);
                    }
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000)

                }
            });
        }
    }
    return (
        <div className="maindiv1" style={{ fontFamily: "Poppins" }}>
            <Container fluid={true} style={{alignItems: "center", justifyContent: "center", display: "flex"}}>
            
                        <div className="text-center bg-white middleDiv1">
                            <div className="innerDiv rounded">
                                <img src="LocusB.png" alt="logo" className="logo" />
                                <div className="text-center mb-1">
                                    <h5 className="margin-header"><b>Sign up into your account</b></h5>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="pb-2">
                                        {/* Full name input field */}
                                        <div className="form-group input-group marginBottomErrorSpan">
                                            <div className="form-group input-group-prepend">
                                                <span className="form-group input-group-text icon-setting left-icons"><BsFillPersonFill /></span>
                                            </div>
                                            <input className="form-control" type="text" style={{textTransform: "capitalize"}} placeholder="Enter your first name" {...register("fName", { required: true, maxLength: 50 })} />
                                            <span className="errorSignSpan">{errors.fName?.type === 'required' && "*First name is required"}</span>
                                        </div>
                                        {/* Last name input field */}
                                        <div className="form-group input-group marginBottomErrorSpan">
                                            <div className="form-group input-group-prepend">
                                                <span className="form-group input-group-text icon-setting left-icons"><BsFillPersonFill /></span>
                                            </div>
                                            <input className="form-control" type="text" style={{textTransform: "capitalize"}} placeholder="Enter your last name" {...register("lName", { required: true, maxLength: 50 })} />
                                            <span className="errorSignSpan">{errors.lName?.type === 'required' && "*Last name is required"}</span>
                                        </div>
                                        {/* Email input field */}
                                        <div className="form-group input-group marginBottomErrorSpan">
                                            <div className="form-group input-group-prepend">
                                                <span className="form-group input-group-text icon-setting left-icons"><BsFillEnvelopeFill /></span>
                                            </div>
                                            <input className="form-control" type="email" placeholder="Enter your email address" {...register("userId", { required: true, maxLength: 50 })} />
                                            <span className="errorSignSpan">{errors.userId?.type === 'required' && "*Email is required"}</span>
                                        </div>

                                        {/* Password input field */}
                                        <div className="form-group input-group marginBottomErrorSpan">
                                            <div className="form-group input-group-prepend">
                                                <span className="form-group input-group-text icon-setting left-icons"><BsFillLockFill /></span>
                                            </div>
                                            <input className="form-control pswd-input" type={pswdTxt} placeholder="Enter your password" {...register("passwd", { maxLength: 20, minLength: 8, required: true })} />
                                            <div className="form-group input-group-postpend">
                                                <span className="form-group input-group-text icon-setting right-icons">
                                                    {pswdIcon ?
                                                        <BsFillEyeFill onClick={e => { setPswdIcon(false); setPswdTxt("password") }} /> :
                                                        <BsFillEyeSlashFill onClick={e => { setPswdIcon(true); setPswdTxt("text") }} />
                                                    }
                                                </span>
                                            </div>
                                            <span className="errorSignSpan">{errors.passwd?.type === 'required' && "*Password is required"}</span>
                                            <span className="errorSignSpan">{errors.passwd?.type === 'maxLength' && "*Password should contain at most 20 characters"}</span>
                                            <span className="errorSignSpan">{errors.passwd?.type === 'minLength' && "*Password should contain at least 8 characters"}</span>
                                        </div>

                                        {/* Confirm Password input field */}
                                        <div className="form-group input-group marginBottomErrorSpan">
                                            <div className="form-group input-group-prepend">
                                                <span className="form-group input-group-text icon-setting left-icons"><BsFillLockFill /></span>
                                            </div>
                                            <input className="form-control pswd-input" type={pswdConTxt} placeholder="Confirm your password" onFocus={() => { setPswdNotMatch(false); setDisButton(false); }} {...register("cpasswd", { required: true })} />
                                            <div className="form-group input-group-postpend">
                                                <span className="form-group input-group-text icon-setting right-icons">
                                                    {pswdConIcon ?
                                                        <BsFillEyeFill onClick={a => { setConPswdIcon(false); setConPswdTxt("password") }} /> :
                                                        <BsFillEyeSlashFill onClick={a => { setConPswdIcon(true); setConPswdTxt("text") }} />
                                                    }
                                                </span>
                                            </div>
                                            <span className="errorSignSpan">{errors.cpasswd?.type === 'required' && "*Confirm password is required"}</span>
                                            <span className="errorSignSpan">{pswdNotMatch && "*Password not matched"}</span>
                                        </div>

                                    </div>
                                    <ToastContainer />
                                    <div className="btn-margin">
                                        <button type="submit" disabled={disButton} className="btnDesg mb-2" style={{marginTop : '10px'}}>
                                            {(disButton && !pswdNotMatch) ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Sign up"}</button>
                                    </div>
                                    <small className="belowBtn">Already have an account? <a href="/" ><span><b>Sign in</b></span></a></small>
                                </form>
                            </div>
                        </div>
                  
            </Container>
            <IdleMonitor/>
        </div>
    );
}

export default Signup;